module.exports = __webpack_public_path__ + "images/84de9f41d6e7a8b517e629b1e92b192a.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro/intro_logo.png
// module id = 583
// module chunks = 24